export { default } from 'ember-text-measurer/services/text-measurer';
